<div
  class="container"
  [class.focus]="inputFocusClass"
  [class.invalid]="invalid"
  [style.width]="width + 'px' || '100%'"
  [style.paddingRight.px]="paddingRight"
  [style.border]="'1px solid' + borderColorHex"
  [style.backgroundColor]="backgroundColorHex || backgroundColor"
>
  @if (!hideLabel) {
    <label [style.color]="labelColorHex">{{ label }}</label>
  }
  <input
    #input
    class="oph-input-inside-label__input"
    [name]="name"
    [formControl]="internalControl"
    (input)="onInput($any($event.target).value)"
    (focus)="onFocus()"
    (blur)="inputFocusClass = false"
    [type]="inputType"
    [style.color]="valueColorHex"
    [style.fontSize.px]="fontSize || 16"
    [readOnly]="disabled"
    [placeholder]="placeholder"
    [ngStyle]="inputStyle"
    [ngClass]="{'oph-input-inside-label__input--no-label': hideLabel}"
  />
  <div
    *ngIf="maxLength && (!charCounterThreshold || maxLength - charCount <= charCounterThreshold)"
    class="oph-input-inside-label__char-counter oph-input-inside-label__char-counter--fade"
    [class.oph-input-inside-label__char-counter--invalid]="maxLength && charCount > maxLength"
  >
    {{ charCount }}/{{ maxLength }}
  </div>
</div>
